export const LOCAL_STORAGE_SELECTED_SETTING_PREFIX = 'selected-setting-';
export const LOCAL_STORAGE_SELECTED_VERSION_PREFIX = 'selected-version-';
export const SETTINGS_DEFAULT_VERSION = 'default';
